import React, { useRef, useState } from "react";
import FileUploadController from "./controller/file-upload.controller";
import If from "../../../vendors/components/If";

interface Props {
  id: any;
  onUpload: any;
  accept: any;
  show: any;
}

export default function FileUpload(props: Props) {
  const controller = new FileUploadController();
  const inputRef = useRef<HTMLInputElement>(null);
  const [dragging, setDragging] = useState(false);

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setDragging(false);
    if (inputRef.current && e.dataTransfer.files.length > 0) {
      const dt = new DataTransfer();
      dt.items.add(e.dataTransfer.files[0]);
      inputRef.current.files = dt.files;
      controller.getFile(props.id, props.onUpload);
    }
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  if (!props.show) return null;

  return (
    <>
      <div
        className={`efu-zone${dragging ? " efu-zone--active" : ""}`}
        onClick={() => inputRef.current?.click()}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
      >
        <svg
          className="efu-zone__icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="17 8 12 3 7 8" />
          <line x1="12" y1="3" x2="12" y2="15" />
        </svg>
        <span className="efu-zone__text">
          Clique para selecionar ou arraste um arquivo
        </span>
        <span className="efu-zone__hint">Máx. 10MB</span>
      </div>
      <If condition={controller.show}>
        <input
          ref={inputRef}
          style={{ display: "none" }}
          id={props.id}
          type="file"
          onChange={() => controller.getFile(props.id, props.onUpload)}
          accept={props.accept}
        />
      </If>
    </>
  );
}
